import { Tooltip } from "react-tooltip";
import { CalendarDaysIcon } from "@heroicons/react/20/solid";
import { BookOpenIcon } from "@heroicons/react/24/outline";
import FormattedDate from "../../../components/FormattedDate";

interface AssignmentInfoProps {
	id: number;
	title?: string;
	subText?: string;
	dueDate?: Date;
	isPastDue?: boolean;
	allComplete: boolean;
	isAssigned?: boolean;
	tooltipContent?: string;
}

export default function AssignmentInfo(props: AssignmentInfoProps) {
	return (
		<div>
			<div className="flex items-center">
				{props.isAssigned && (
					<span>
						<BookOpenIcon
							tabIndex={-1}
							className="size-5 mr-2 text-gray-700"
							data-tooltip-id={`assigned-${props.id}-tooltip`}
						/>
						<Tooltip
							id={`assigned-${props.id}-tooltip`}
							place="top-start"
							content={props.tooltipContent}
						/>
					</span>
				)}
				<p className="text-md font-medium text-gray-700">{props.title}</p>
			</div>
			<p className="text-sm text-gray-700">{props.subText}</p>
			{props.dueDate && (
				<div className="ml-2 my-1 flex">
					<CalendarDaysIcon
						tabIndex={-1}
						className={`${props.isPastDue && !props.allComplete ? "text-red-500" : "text-gray-700"} mr-1.5 h-5 w-5`}
						aria-hidden="true"
					/>
					<div className="inline-flex sm:flex-col md:flex-row">
						<p
							className={`${props.isPastDue && !props.allComplete ? "text-red-500" : "text-gray-700"} px-1 text-xs leading-5`}>
							DUE <FormattedDate date={props.dueDate} />
						</p>
						{props.isPastDue && !props.allComplete && (
							<p className="text-red-500 ml-0.5 text-xs leading-5">- PAST DUE</p>
						)}
					</div>
				</div>
			)}
		</div>
	);
}
